import { ActionButton, HeadingItem } from 'components';
import { faPencil, faCheckCircle, faTrash, faTimes, faThumbsUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, Fragment, useState } from 'react'
import { useContext } from 'react'
import { TripContext } from 'contexts';
import './verify-company-email-card.scss'
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ConfirmationPopup } from 'components/pop-up';
import { useEmailService } from 'services/useEmailService';
import { useNavigation } from 'services';
import { Stop } from 'services/types';

type Props = {
    isEditEmailPage: boolean,
    emailHeaderText: string,
    stopId: number,
    onBeforeEditEmail?: () => void
}

export const VerifyCompanyEmailCard: FC <Props> = ({isEditEmailPage, emailHeaderText, stopId, onBeforeEditEmail }) => {
    const tripContext = useContext(TripContext)
    const { navigateTo } = useNavigation()
    const [emailIdBeingDeleted, setEmailIdBeingDeleted] = useState<number|null>(null);
    const { deleteEmailFromContext } = useEmailService();
    const stop: Stop = tripContext.stops.find(stop => stop.id == stopId) ?? {} as Stop
    const companyId = stop.companyId;
    const companyEmails = tripContext.companyEmail.filter(email => email.companyId == companyId) ?? [];

  const onClickEditEmail = () => {
    onBeforeEditEmail?.();
    navigateTo(`/edit-company-emails?stopId=${stopId}`);
  }

    const handleIconClick = (id: number) => {
        setEmailIdBeingDeleted(id)
    }

    const handleDeleteEmail = (id: number) => {
        deleteEmailFromContext(id);
        setEmailIdBeingDeleted(null)
    };

    return (
        <Fragment>
            <div className={'card-material'}>
                <HeadingItem 
                    text= {emailHeaderText} 
                    /> 
            <div>
            {companyEmails.length > 0 ? (
                <table className="email-table">
                <thead>
                    <tr>
                        <th className='email-column'>E-mail</th>
                        <th className='icon-column'>Pre-Delivery</th>
                        <th className='icon-column'>Post-Delivery</th>
                        {isEditEmailPage && <th className='icon-column'>Delete</th>}
                    </tr>
                </thead>
                
                <tbody>
                    {companyEmails.map(email => (
                        <tr key={email.id}>
                        <td className='email-cell'>{email.email}</td>
                        <td className='email-table-icons'>
                            {email.isPredelivery ? <FontAwesomeIcon icon={faCheckCircle as IconProp} color={'#76AB21'} /> : ''}
                        </td>
                        <td className='email-table-icons'>
                            {email.isPostdelivery ? <FontAwesomeIcon icon={faCheckCircle as IconProp} color={'#76AB21'} />: ''}
                        </td>
                        {isEditEmailPage && <td>
                            {<FontAwesomeIcon 
                                icon={faTrash as IconProp} 
                                color={'Red'} 
                                onClick={() => handleIconClick(email.id)}
                                />}
                        </td>}
                        </tr>
                    ))}
                </tbody>
                </table>
                      ) : (
                        <div>None</div>
                      )}
            </div>
                <div className='edit-email-button'>
                    {!isEditEmailPage && <ActionButton
                        icon={faPencil}
                        buttonColor={'#f2994a'}
                        onClick={onClickEditEmail}
                        buttonText={'Edit E-mail'}
                    />}     
                </div>
                <div>
                    <ConfirmationPopup
                        isVisible={emailIdBeingDeleted!=null}
                        title="Confirm Delete Email"
                        message={`Are you sure you want to delete this email address?`}
                        button1={{ icon: faTimes }}
                        button2={{ icon: faThumbsUp }}
                        onClickButton1={() => setEmailIdBeingDeleted(null)}
                        onClickButton2={() => handleDeleteEmail(emailIdBeingDeleted!)}
                    />
                </div>
            </div>
        </Fragment>
    )
}